// ** React Imports
import React from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledTableCell = styled(
	({
		hidden,
		nowrap,
		linkable,
		nohover,
		center,
		min,
		isMain,
		maxWidth,
		...props
	}) => React.createElement("td", props),
)`
	position: relative;
	vertical-align: middle;
	padding: 0.75rem;

	${({ maxWidth }) =>
		maxWidth &&
		css`
			max-width: ${maxWidth};
		`}

	${({ hidden }) =>
		hidden &&
		css`
			display: none;
		`}
	${({ nowrap }) =>
		nowrap &&
		css`
			white-space: nowrap;
		`}
	${({ center }) =>
		center &&
		css`
			text-align: center;
			align-items: center;
			justify-content: center;
		`}
	${({ isMain }) =>
		isMain &&
		css`
			width: 100%;
		`}
	${({ linkable }) =>
		linkable &&
		css`
			padding: 0;
			a {
				padding: 1rem;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				background-color: transparent;
				${({ nohover }) =>
					!nohover &&
					css`
						&:hover {
							background-color: ${({ theme: { colors } }) =>
								colors.white};
						}
					`}
			}
		`}

	${({ lowerCheckPadding }) =>
		lowerCheckPadding &&
		css`
			padding-left: 0.25rem;
		`}
`;

// #####################################################
